export default __webpack_public_path__ + "static/media/comment.7e0afaea.svg";